import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { showError, showSuccess } from "../utils/toast";
import { useAuth } from "../context/AuthContext";


const ProfileEditModal = ({ show, onHide, user }) => {
  const [profileData, setProfileData] = useState({
    name: '',
    contactNumber: '',
    email: '',
    password: '',
    role: ''
  });

const { updateUser } = useAuth();

  useEffect(() => {
    if (show && user) {
      setProfileData({
        name: user.name || '',
        contactNumber: user.contactNumber || '',
        email: user.email || '',
        password: '',
        role: user.role
      });
    }
  }, [show, user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/api/update-user/${user?.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: user?.id,
          ...profileData
        })
      });

      const res = await response.json();
      
      if (response.ok) {
        updateUser(res.user);  // 👈 Update context + localStorage
        showSuccess('Profile updated successfully!');
        onHide();
      } else {
        showError('Failed to update profile');
      }
    } catch (error) {
      showError('Error updating profile');
      console.error(error);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered style={{zIndex:"9999999"}} 
        backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Edit Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={profileData.name}
              onChange={handleInputChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="tel"
              name="contactNumber"
              value={profileData.contactNumber}
              onChange={handleInputChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={profileData.email}
              onChange={handleInputChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Leave blank to keep current"
              value={profileData.password}
              onChange={handleInputChange}
            />
          </Form.Group>

          <div className="d-flex gap-2">
            <Button variant="secondary" onClick={onHide} className="flex-grow-1">
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="flex-grow-1">
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ProfileEditModal;